<template>
    <el-form ref="formRef" :model="passwordForm" :rules="rules" class="login-form" label-position="top">
        <el-form-item label="设置密码" prop="newPassword">
            <el-input
                type="password"
                show-password
                size="large"
                v-model="passwordForm.newPassword"
                placeholder="请设置6-16位包含字母、数字的密码"
                maxlength="20"
            />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
                type="password"
                show-password
                size="large"
                v-model="passwordForm.confirmPassword"
                placeholder="请再次输入"
                maxlength="20"
            />
        </el-form-item>
        <el-form-item class="mt-20" size="large">
            <div class="login-btn">
                <el-button size="large" @click="emits('cancel')">取消</el-button>
                <el-button size="large" type="primary" @click="clickLoginBtn" :loading="btnLoading" :disabled="isSubmitDisabled"
                    >确认</el-button
                >
            </div>
        </el-form-item>
    </el-form>
</template>

<script lang="ts" setup>
import { computed, reactive, ref } from "vue";
import { ElButton, FormInstance } from "element-plus";
import { userService } from "@/api/services/userService";
import { ElMessage, ElFormItem, ElForm, ElInput } from "element-plus";

const emits = defineEmits(["getToken", "cancel"]);

const passwordForm = reactive({ newPassword: "", confirmPassword: "" });
const btnLoading = ref<boolean>(false);
const isSubmitDisabled = computed(() => {
    return !(passwordForm.newPassword && passwordForm.confirmPassword);
});
const rules = {
    newPassword: [
        { required: true, message: "请输入新密码", trigger: "blur" },
        { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/, message: "请设置6-16位包含字母、数字的密码", trigger: "blur" }
    ],
    confirmPassword: [
        { required: true, message: "请再次输入新密码", trigger: "blur" },
        {
            validator: (_rule: unknown, value: string, callback: (error?: Error) => void) => {
                if (value !== passwordForm.newPassword) {
                    callback(new Error("两次密码输入不一致"));
                } else {
                    callback();
                }
            },
            trigger: "blur"
        }
    ]
};
const formRef = ref<FormInstance>();

/** 点击登录 */
const clickLoginBtn = () => {
    formRef.value!.validate(async valid => {
        if (valid) {
            try {
                btnLoading.value = true;
                await userService.password(passwordForm);
                ElMessage.success("密码设置成功");
                // 设置密码成功返回登录页
                emits("cancel");
                btnLoading.value = false;
            } catch (err) {
                console.error(err);
                btnLoading.value = false;
            }
        }
    });
};
</script>

<style lang="scss" scoped>
.login-btn {
    display: flex;
    width: 100%;
    gap: 10px;
    > .el-button {
        flex: 1;
        margin: 0;
    }
}
.mt-80 {
    margin-top: 80px;
}
</style>
